import { AuthState } from '../providers/AuthProvider';
import useAuth from './useAuth';

// ECDEX-3441 (MR F): the auth state the app gate (Layout, useAuthReady, Auth)
// and the login pages read. It is the AuthProvider Context and nothing else:
// the candidateLogin reducer and portal.loggedIn / loggedOut are gone from
// Redux. The name stays so the readers do not all change, and the one place
// that decides where auth state comes from stays one place.
const useAuthGateState = (): AuthState => useAuth().state;

export default useAuthGateState;
